module.exports = __webpack_public_path__ + "static/media/profile.9c8344b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile.svg
// module id = 519
// module chunks = 1